import {escapeRegExp} from 'lodash';

const sanitizeErrors = (errors: Record<string, any>): Record<string, any> =>
  Object.entries(errors).reduce((sanitized, [key, value]) => {
    // Remove keys which have additional property errors in error-dotobject
    // because converting these to actual objects (required for final-form)
    // is not possible without very strange results
    // e.g.
    // { HuidigObject: [...], HuidigObject.0.StraatNaam: [...] }
    // removes HuidigObject: [...]
    // result actual object: { HuidigObject: [{StraatNaam: [...]}] }
    // 
    const matchAdditionalProps = new RegExp(`^${escapeRegExp(key)}\\..*$`);
    if ( ! Object.keys(errors).some(k => matchAdditionalProps.test(k))) {
      sanitized[key] = value;
    }
    return sanitized;
  }, {});

export default sanitizeErrors;
